<template>
  <div class="classBPage" :class="{ firstPage: firstPage }">
    <div v-if="!isLoading" class="classBContainer">
      <div class="classCHeader">
        <div class="sectionHeaderColumn picColumn">
          <div class="headerBackBtn" @click="routeBackHandler">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>
          <img :src="data.img" alt="default" />
        </div>
      </div>
      <div class="classMain">
        <div class="mainSection">
          <div class="sectionTitle">
            {{ data.title }}
          </div>
          <div class="sectionDetails">
            <div class="setionViews">
              <div class="viewsValue">
                <i class="fa-regular fa-user"></i> <span>نویسنده: {{ data.author }}</span></div>
            </div>
            <div>
            <div class="sectionDate">
              <div class="dateIcon">
                <i class="fas fa-calendar"></i>
              </div>
              <div class="dateValue">{{ formattedDate }}</div>
            </div>
            <div class="setionViews">
              <div class="viewsIcon">
                <i class="fa-regular fa-eye"></i>
              </div>
              <div class="viewsValue">{{ data.view }} بازدید</div>
            </div>
            <div v-if="data.sub_cat_title" class="setionViews">
              <div class="viewsValue">{{ data.sub_cat_title }}</div>
            </div>
            </div>
          </div>
          <div class="sectionDesc" v-html="data.content"></div>
        </div>

        <div class="mainSection adsSection" v-if="same_artile.length > 0">
          <div class="sectionTitle">
            مقالات مرتبط
          </div>
          <div
            v-for="(v, i) in same_artile"
            class="newsThumb"
            :key="i"
            @click="changeRouteHandler(v.id)"
          >
            <div class="thumbPic">
                <img :src="v.img" alt="" />
              </div>
              <div class="thumbContent">
                <div class="contentMain">
                  <div v-if="v.sub_cat" class="contentCat">
                    {{ v.sub_cat }}
                  </div>
                  <div class="contentTitle">
                    {{ v.title }}
                  </div>
                  <div class="contentDesc" v-html="v.content"></div>
                  <div class="uploadDetailsWrapper">
                    <div class="uploadDate">
                      <div class="dateIcon">
                        <i class="far fa-clock"></i>
                      </div>
                      <div class="dateTitle">{{ v.created_fa }}</div>
                    </div>
                    <div class="veiwsNum">
                    <div class="numIcon">
                      <i class="far fa-eye"></i>
                    </div>
                    <div class="num">{{ v.view }} بازدید</div>
                  </div>
                  </div>
                </div>
                <!-- <div class="contentFooter">
                  <div class="readMoreLink">
                    <div class="linkIcon">
                      <VsxIcon
                        iconName="HambergerMenu"
                        :size="16"
                        color="#000"
                        type="linear"
                      />
                    </div>
                    <div class="linkeTitle">مطالعه بیشتر</div>
                  </div>
                  <div class="veiwsNum">
                    <div class="numIcon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                      </svg>
                    </div>
                    <div class="num">{{ v.view }} بازدید</div>
                  </div>
                </div> -->
              </div>
          </div>
        </div>
      </div>
    </div>
    <blockLoading v-if="isLoading" />
  </div>
</template>

<script>
import blockLoading from "@/components/blockLoading/blockLoading.vue";
export default {
  name: "newsDetails",
  components: { blockLoading },
  data() {
    return {
      firstPage: false,
      isLoading: true,
      data: [],
      same_artile: [],
    };
  },
  computed: {
    formattedDate() {
      if (!this.data.created_fa) return "";
      try {
        const withoutDay = this.data.created_fa.split(",")[1]?.trim() || "";
        return withoutDay.split("-")[0]?.trim() || "";
      } catch (e) {
        return "";
      }
    },
  },
  mounted() {
    const routePrev = sessionStorage.getItem("prevPage");
    if (routePrev == "firstPage") {
      this.firstPage = true;
    } else {
      this.firstPage = false;
    }

    this.getdetail();
  },
  watch: {
    "$route.query.id"(newId, oldId) {
      if (newId !== oldId) {
        this.getdetail();
      }
    },
  },
  methods: {
    routeBackHandler() {
      history.back();
    },
    getdetail: async function () {
      this.data = [];
      let self = this;
      this.isLoading = true;
      await this.helperPost("article-detail", { news_id: self.$route.query.id })
        .then(function (r) {
          const result = r.data;
          if (result.result === "1") {
            self.data = result.data;
            self.same_artile = result.same_artile.filter(
              (article) => article.id != self.data.id
            );
            console.log("same_artile", self.same_artile);
          }
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
        });
      this.isLoading = false;
    },
    changeRouteHandler(id) {
      this.$router.push({
        query: { id },
      });
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.classCHeader {
  background: rgba(0, 0, 0, 0.4);
  .picColumn {
    img {
      object-fit: contain !important;
    }
  }
}

.dark {
  .classCHeader:not(.firstPage) {
    .picColumn {
      .headerBackBtn {
        background: #101a23;
        box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.15);
      }
    }
  }
}
</style>
